export default __webpack_public_path__ + "static/media/boost-activate-your-perks.94609056.png";